<template>
	<v-dialog
			ref="dateDialog"
			v-model="dateModal"
			persistent
			:return-value.sync="internalValue"
			:width="withTime ? '580px' : '290px'"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
					ref="inputField"
					:value="withTime ? getDisplayLocalDateTime(internalValue) : getDisplayLocalDate(internalValue)"
					v-bind="attrs"
					append-icon="mdi-calendar"
					:class="{
						'rounded-lg': true,
						'required': required
					}"
					:clearable="clearable"
					:hide-details="hideDetails"
					:hint="hint"
					:label="label"
					outlined
					:persistent-hint="persistentHint"
					readonly
					v-on="on"
					@click:append.stop="clearValue"
					@click:clear="$emit('cleared')"
					@focus="$emit('focus', true)"
					:rules="rules"
					:disabled="disabled"
			></v-text-field>
		</template>
		<v-date-picker
				v-model="computedPickerDate"
				:max="max"
				:min="min"
				no-title
		>
			<v-row>
				<v-col cols="12" sm="12" md="12" lg="12">
					<v-time-picker
							v-if="withTime"
							v-model="computedPickerTime"
							ampm-in-title
							color="primary"
							full-width
							:disabled="!internalValue"
					></v-time-picker>
				</v-col>

				<v-col>
					<div class="d-flex justify-end">
						<v-btn
								class="me-2 rounded-lg"
								color="grey darken-1"
								depressed
								outlined
								small
								@click="dateModal = false"
						>
							Cancel
						</v-btn>
						<v-btn
								class="rounded-lg"
								color="primary"
								depressed
								small
								@click="$refs.dateDialog.save(internalValue)"
						>
							Select
						</v-btn>
					</div>
				</v-col>
			</v-row>
		</v-date-picker>
	</v-dialog>

</template>

<script>
import {helpers} from '../helpers';

export default {
	name: "BwDateTimePicker",
	props: {
		clearable: Boolean,
		disabled: Boolean,
		value: {
			type: String,
		},
		label: {
			type: String,
			default: ''
		},
		max: {
			type: String,
			default: Bandwango?.config?.maxDate,
		},
		min: String,
		required: Boolean,
		rules: {
			type: Array,
			default: () => []
		},
		withTime: Boolean,
		tz: {
			type: String,
			default: null
		},
		hideDetails: {
			type: Boolean | String,
			default: 'auto'
		},
		hint: {
			type: String,
			default: ''
		},
		persistentHint: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dateModal: false,
			internalValue: this.value
		};
	},
	computed: {
		computedPickerDate: {
			get() {
				return helpers.getLocalDate(this.internalValue, this.tz);
			},
			set(v) {
				this.internalValue = helpers.getUtcDate(v, this.tz);
				this.$emit('input', this.internalValue);
			}
		},
		computedPickerTime: {
			get() {
				return helpers.getLocalTime(this.internalValue, this.tz);
			},
			set(v) {
				this.internalValue = helpers.getUtcDateTime(helpers.getLocalDate(this.internalValue, this.tz)+' 00:00', v, this.tz);
				this.$emit('input', this.internalValue);
			}
		}
	},
	methods: {
		clearValue() {
			this.internalValue = '';
			this.$emit('input', this.internalValue);
		},
		getDisplayLocalDate(date) {
			return helpers.getDisplayLocalDate(date, this.tz);
		},
		getDisplayLocalDateTime(dateTime) {
			return helpers.getDisplayLocalDateTime(dateTime, this.tz);
		},
		validate() {
			if (this.$refs.inputField) {
				return this.$refs.inputField.validate();
			}
		},
	},
	watch: {
		value: {
			handler(newVal) {
				this.internalValue = newVal;
			}
		}
	}
}
</script>
